import Image from 'react-bootstrap/Image';
import Container from 'react-bootstrap/Container';
import Information from './Information';
import me from '../images/me.jpeg';
import './Header.css'


function Header() {
  return (
    <div className='section'>
      <Container>
        <Image roundedCircle src={me}></Image>
        <p><strong>Email: </strong><a href='mailto:traylorboy@proton.me'>traylorboy@proton.me</a></p>
        <p><strong>Phone Number: </strong><a href='tel: +16308356705'>+1 (630) 835-6705</a></p>
        <div><Information></Information></div>
      </Container>
    </div>
  )
}

export default Header;
